import CheckMarkIcon from './check-mark-icon';
import { MDSText } from '@thrivent/midwest-web';
import styled from 'styled-components';

export interface CheckMarkListProps {
  items: string[];
}

const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
  gap: 0.5rem;
  padding-bottom: 1rem;
  display: flex;
  align-items: center;
`;

const { BodyHeavyDefault } = MDSText;

const CheckMarkList: React.FC<CheckMarkListProps> = ({ items }) => {
  return (
    <List data-testid="check-mark-list">
      {items.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ListItem key={index}>
          <CheckMarkIcon />
          <BodyHeavyDefault>{item}</BodyHeavyDefault>
        </ListItem>
      ))}
    </List>
  );
};

export default CheckMarkList;
